import { useCallback, useState } from 'react';
import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH_FOR_COMPLETE } from '@/consts';
import { useStores } from '@/stores';

export default function useJoinPwdSettingView(onClick: () => void) {
  const { userStore } = useStores();
  const [checkPassword, setCheckPassword] = useState('');
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const isCompleteBtnDisabled = userStore.password !== checkPassword;
  const isCheckPasswordDisabled = (userStore.password?.length ?? 0) < MIN_PASSWORD_LENGTH_FOR_COMPLETE;

  const onChangePassword = useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      const value = e.currentTarget.value;
      const truncated = value.slice(0, MAX_PASSWORD_LENGTH);

      userStore.setPassword(truncated);
    },
    [userStore],
  );

  const onChangeCheckPassword = useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      if (isCheckPasswordDisabled) {
        e.preventDefault();
        return;
      }

      const value = e.currentTarget.value;
      const truncated = value.slice(0, MAX_PASSWORD_LENGTH);
      setCheckPassword(truncated);
    },
    [isCheckPasswordDisabled],
  );

  const onKeyDownCheckPassword = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (isCheckPasswordDisabled) {
        e.preventDefault();
      }
    },
    [isCheckPasswordDisabled],
  );

  const onClickCompleteBtn = useCallback(() => {
    userStore.setPassword(checkPassword);
    onClick();
  }, [userStore, checkPassword, onClick]);

  const onBlurPassword = useCallback((e: React.SyntheticEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;

    // 8자 이상 20자 이하 검사
    const isLengthValid = value.length >= 8 && value.length <= 20;
    // 영문, 숫자, 특수문자 포함 여부 검사
    const hasLetter = /[a-zA-Z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const isValid = isLengthValid && hasLetter && hasNumber && hasSpecial;

    if (!isValid) setIsPasswordValid(false);
    else setIsPasswordValid(true);
  }, []);

  return {
    password: userStore.password,
    checkPassword,
    isCompleteBtnDisabled,
    isPasswordValid,
    isCheckPasswordDisabled,
    onChangePassword,
    onChangeCheckPassword,
    onClickCompleteBtn,
    onBlurPassword,
    onKeyDownCheckPassword,
  };
}
